export enum JointStatusEnum {
  Active = 1,
  Closed = 2
}

export const JointStatusStringEnum = {
  Active: 'Active',
  Closed: 'Closed'
};
